import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'tournament-fixture-match-result',
  templateUrl: './tournament-fixture-match-result.component.html',
  styleUrls: ['./tournament-fixture-match-result.component.scss'],
})

export class TournamentFixtureMatchResultComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _tournamentService: TournamentsService,
    private _snackbar: MatSnackBar
  ) { }

  @Output() closeDialogEvent = new EventEmitter<boolean>();
  scoreTeamA = new FormControl("", [Validators.min(0), Validators.required]);
  scoreTeamB = new FormControl("", [Validators.min(0), Validators.required]);

  ngOnInit() {
    
  }

  closeDialog() {
    this.closeDialogEvent.emit(true);
  }

  loadResult() {
    const scores = {
      score_team_a: this.scoreTeamA.value,
      score_team_b: this.scoreTeamB.value
    };
    this._tournamentService.loadMatchScore(this.data.tournamentId, this.data.fixtureId, this.data.roundId, this.data.id, scores).subscribe((res) => {
      this.closeDialogEvent.emit(true);
    }, (err) => this._snackbar.open("Error al cargar resultado del partido", "", { duration: 3000 }));
  }
}